<template>
  <div class="leave_request">
    <div class="leave__loader" v-if="pageloader">
      <div>
        <PageLoader />
      </div>
    </div>
    <div class="leave__error" v-if="errorDiv">{{ errorMessage }}</div>

    <div class="leave_request__list" v-if="!pageloader">
      <div class="leave_request__card" v-for="(leave, index) in leaveRequest" :key="index">
        <div>
          <!-- <div class="leave_request__card--profile">
            <div>
              <img src="./../../../assets/images/leave.png" alt />
            </div>
            <p>Edmond Benson</p>
          </div> -->
          <div class="leave_request__card--content">
            <div>
              <div class="leave_request__card--content-key">Leave Type:</div>
              <div class="leave_request__card--content-value">{{ leave.leave_type.type }}</div>
            </div>
            <div>
              <div class="leave_request__card--content-key">Number of days:</div>
              <div class="leave_request__card--content-value">{{ leave.no_of_days }}</div>
            </div>
            <div>
              <div class="leave_request__card--content-key">From:</div>
              <div class="leave_request__card--content-value">{{ leave.start_date }}</div>
            </div>
            <div>
              <div class="leave_request__card--content-key">To:</div>
              <div class="leave_request__card--content-value">{{ leave.end_date }}</div>
            </div>
            <div>
              <div class="leave_request__card--content-key">Reason:</div>
              <div class="leave_request__card--content-value">{{ leave.reason }}</div>
            </div>

            <div>
              <div class="leave_request__card--content-key">Approver:</div>
              <div
                class="leave_request__card--content-value"
              >{{ leave.approval.firstname }} {{ leave.approval.lastname }}</div>
            </div>

            <div>
              <div class="leave_request__card--content-key">Line Manager:</div>
              <div
                class="leave_request__card--content-value"
              >{{ leave.line_manager.firstname }} {{ leave.line_manager.lastname }}</div>
            </div>

            <div>
              <div class="leave_request__card--content-key">Status:</div>
              <div class="leave_request__card--content-value" v-if="leave.status === 0">
                <span style="color: rgba(0, 0, 0, 0.5);">
                  <font-awesome-icon icon="exclamation-triangle" />
                </span>&nbsp;
                <span style="font-size: 10px;">Pending</span>
              </div>

              <div class="leave_request__card--content-value" v-if="leave.status === 1">
                <span style="color: green;">
                  <font-awesome-icon icon="check" />
                </span>&nbsp;
                <span style="font-size: 10px;">Approved</span>
              </div>

              <div class="leave_request__card--content-value" v-if="leave.status === 2">
                <span style="color: red;">
                  <font-awesome-icon icon="times" />
                </span>&nbsp;
                <span style="font-size: 10px;">Rejected</span>
              </div>

              <div class="leave_request__card--content-value" v-if="leave.status === 3">
                <span style="color: red;">
                  <font-awesome-icon icon="times" />
                </span>&nbsp;
                <span style="font-size: 10px;">Cancelled</span>
              </div>
            </div>
          </div>
          <div class="leave_request__card--btn">
            <div
              class="leave_request__card--btn-approve"
              @click="leaveApproval(leave.id, 1)"
            >Approve</div>

            <div class="leave_request__card--btn-reject" @click="leaveApproval(leave.id, 2)">Reject</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import PageLoader from "../../partials/page-loader";

export default {
  name: "LeaveRequest",
  components: {
    PageLoader
  },
  data() {
    return {
      pageloader: true,
      errorDiv: true,
      leaveRequest: []
    };
  },
  created() {
    this.leaveApplications();
  },
  methods: {
    leaveApplications() {
      this.errorDiv = false;
      this.errorMessage = null;

      this.$http
        .get(types.LEAVE_APPLICATIONS)
        .then(resp => {
          this.leaveRequest = [...resp.data.data];
          this.pageloader = false;

          console.log(this.leaveRequest);
        })
        .catch(err => {
          this.pageloader = false;
          this.errorDiv = true;
          this.errorMessage = "Server errror. Please try again later.";
        });
    },
    leaveApproval(id, num) {
      this.pageloader = true;
      this.errorDiv = false;
      this.errorMessage = null;

      this.$http
        .post(types.LEAVE_APPROVAL, {
          request_id: id,
          approval: num
        })
        .then(resp => {
          this.leaveApplications();
          this.pageloader = false;
        })
        .catch(err => {
          this.pageloader = false;
          this.errorDiv = true;
          this.errorMessage = "You already reviewed this request.";
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.leave_request {
  padding: 20px 0 100px 0;

  > .leave__loader {
    > div {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;
    }
  }

  > .leave__error {
    border: 1px solid red;
    margin-bottom: 10px;
    padding: 10px;
    background-color: rgba(255, 0, 0, 0.4);
    color: #fff;
    font-size: 14px;
    text-align: left;
  }

  > .leave_request__list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    align-content: center;

    > .leave_request__card {
      padding: 20px;
      width: 33.333333333%;
      > div {
        padding: 20px;
        border-radius: 10px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
        background-color: #ffffff;

        > .leave_request__card--profile {
          > div {
            width: 50px;
            height: 50px;
            margin: auto;
          }

          > p {
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 2;
            letter-spacing: normal;
            text-align: center;
            color: #5099de;
          }
        }

        > .leave_request__card--content {
          margin: 20px 0;

          > div {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: flex-start;
            justify-content: center;
            align-content: center;
            padding: 5px 0;
            border-bottom: 1px solid rgba(0, 0, 0, 0.2);

            > .leave_request__card--content-key {
              width: 50%;
              font-size: 12px;
              font-weight: normal;
              font-stretch: normal;
              font-style: normal;
              text-align: left;
              color: #707070;
            }

            > .leave_request__card--content-value {
              width: 50%;
              font-size: 14px;
              font-weight: 300;
              font-stretch: normal;
              font-style: normal;
              text-align: left;
              color: #000000;
            }
          }
        }

        > .leave_request__card--btn {
          width: 90%;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: space-between;
          align-content: center;
          margin: auto;

          > .leave_request__card--btn-approve {
            width: 45%;
            height: 40px;
            border-radius: 5px;
            border: solid 1px #5099de;
            background-color: #5099de;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.2;
            letter-spacing: normal;
            text-align: center;
            color: #ffffff;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
            cursor: pointer;
          }

          > .leave_request__card--btn-reject {
            width: 45%;
            height: 40px;
            border-radius: 5px;
            border: solid 1px #5099de;
            background-color: #ffffff;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.2;
            letter-spacing: normal;
            text-align: center;
            color: #5099de;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
